<template>
  <section id="home" class="hero section hero-studio" aria-labelledby="home-title">
    <div class="hero-feature">
      <div class="hero-content">
        <h1 id="home-title" class="hero-title">Zearloops is an independent game studio.</h1>
        <p class="hero-subtitle">
          Based in Argentina, we develop original games in-house and collaborate with artists on each project.
        </p>

        <div class="hero-actions">
          <router-link :to="{ path: '/', hash: '#about' }" class="btn btn-primary">Meet the studio</router-link>
        </div>
      </div>

      <aside class="hero-project" aria-labelledby="hero-project-title">
        <div class="hero-project-heading">
          <h2 id="hero-project-title" class="hero-project-title">{{ game.title }}</h2>
          <span class="hero-status">{{ game.statusLabel }}</span>
        </div>

        <figure class="hero-artwork">
          <img
            :src="game.screenshots.bosses.image"
            :alt="game.screenshots.bosses.alt"
            width="1280"
            height="720"
            fetchpriority="high"
            decoding="async"
          >
        </figure>

        <div class="hero-project-footer">
          <p class="hero-project-meta">Featured project · {{ game.genre }}</p>
          <router-link to="/game/epic-rifts" class="hero-project-link">Explore the game</router-link>
        </div>
      </aside>
    </div>
  </section>
</template>

<script>
import { gamesBySlug } from '@/data/games';

export default {
  name: 'HeroSection',
  data() {
    return {
      game: gamesBySlug['epic-rifts']
    };
  }
};
</script>